import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from './api';

// Créer une nouvelle Depense
export const useCreateDepense = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/depenses/createDepense', data),
    onSuccess: () => queryClient.invalidateQueries(['depenses']),
  });
};

// Mettre à jour une Depense
export const useUpdateDepense = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) =>
      api.put(`/depenses/updateDepense/${id}`, data),
    onSuccess: () => queryClient.invalidateQueries(['depenses']),
  });
};
// Lire toutes les depenses
export const useAllDepenses = () =>
  useQuery({
    queryKey: ['depenses'],
    queryFn: () => api.get('/depenses/getAllDepense').then((res) => res.data),
  });

// Lire toutes les depenses with pagignation
export const usePagignationDepenses = (
  page = 1,
  limit = 30,
  search = '',
  boutique = null,
  today = null
) =>
  useQuery({
    /**
     * AJOUT (cache pro):
     * Avant: queryKey = ['depenses', page, limit] => cache incohérent quand search/boutique/today change.
     * Maintenant: on inclut les filtres.
     * NB: on ne change pas le nom du hook ni l'URL API.
     */
    queryKey: ['depenses', page, limit, search, boutique, today],
    queryFn: () =>
      api
        .get('/depenses/getPagignationDepense', {
          /**
           * AJOUT:
           * On passe search/boutique/today au backend pour filtrer AVANT pagination.
           */
          params: {
            page,
            limit,
            search: search || undefined,
            boutique: boutique ?? undefined,
            today: today ? '1' : undefined,
          },
        })
        .then((res) => res.data),
    keepPreviousData: true,
    staleTime: 1000 * 30,
  });

// Obtenir une Depense
export const useOneDepense = (id) =>
  useQuery({
    queryKey: ['depenses', id],
    queryFn: () =>
      api.get(`/depenses/getDepenseById/${id}`).then((res) => res.data),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, // chaque 5 minutes rafraichir les données
  });

// Supprimer une Depense
export const useDeleteDepense = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/depenses/deleteDepense/${id}`),
    onSuccess: () => queryClient.invalidateQueries(['depenses']),
  });
};
